import React from 'react';

const Error = ({ text }: { text: string }) => {
	return <div>{text}</div>;
};

export default Error;
